import React, { Fragment, useEffect, useContext, useState } from "react";

/* packages */
import { GlobalProvider } from "../../lib-atomic-context";
import {
  ModuleContainerLg,
  ModulePaddedWrapperLg,
  ModuleFormWrapper,
  ModuleTitle,
} from "../../lib-atomic-design-section";
/* packages */

/* container */
import CMSContainer from "../../app-module-cms-container/default";
import Container from "../../app-module-account-profile-container/default";
/* container */

/* module */
import CMSHomeHeader from "../../app-module-cms-section-home-header/default";
import ProfileUpdateForm from "../form/updateProfile";
/* module */

const index = (props) => {
  return (
    <GlobalProvider>
      <CMSContainer>
        <CMSHomeHeader {...props} />
      </CMSContainer>

      <ModuleContainerLg>
        <ModulePaddedWrapperLg>
          <Container.AccountUpdate {...props}>
            <ModuleFormWrapper>
              <ModuleTitle>Update Profile Details</ModuleTitle>
              <ProfileUpdateForm {...props} />
            </ModuleFormWrapper>
          </Container.AccountUpdate>
        </ModulePaddedWrapperLg>
      </ModuleContainerLg>
    </GlobalProvider>
  );
};

export default index;
